import { Badge, badgeClasses, Box, IconButton, Paper, Stack, Typography } from '@mui/material'
import { CustomContentProps, useSnackbar } from 'notistack'
import { forwardRef } from 'react'
import CloseIcon from '../../assets/icons/Close.svg?react'
import { NotificationIcon } from '../NotificationIcon'

declare module 'notistack' {
    interface VariantOverrides {
        push: {
            title: string
            eventCode: string
        }
    }
}

interface Props extends CustomContentProps {
    title: string
    eventCode: string
}

export const Notification = forwardRef<HTMLDivElement, Props>(
    ({ id, title, message, eventCode }, ref) => {
        const { closeSnackbar } = useSnackbar()

        const handleClose = () => {
            closeSnackbar(id)
        }

        return (
            <Paper
                ref={ref}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '100%',
                    width: '365px',
                    borderRadius: '16px',
                    boxShadow: '0px 4px 33px 0px #0000000F',
                    padding: '8px 4px 16px 16px',
                }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center" gap={1}>
                        <Badge
                            badgeContent={0}
                            showZero
                            color="error"
                            variant="dot"
                            sx={{
                                [`.${badgeClasses.badge}`]: {
                                    border: '1px solid #FFFFFF',
                                    p: 0,
                                    borderRadius: '50%',
                                    fontSize: '10px',
                                    minWidth: '12px',
                                    height: '12px',
                                    transform: 'scale(1) translate(15%, -15%)',
                                },
                            }}>
                            <Box
                                sx={{
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#EFF6FF',
                                    borderRadius: '50%',
                                }}>
                                <NotificationIcon compact eventCode={eventCode} />
                            </Box>
                        </Badge>
                        <Typography variant="caption2" color="#9195A1">
                            Сегодня
                        </Typography>
                    </Stack>

                    <IconButton size="large" onClick={handleClose}>
                        <CloseIcon color="#5A5F72" />
                    </IconButton>
                </Stack>
                <Stack gap="4px" pr={1}>
                    <Typography variant="h6">{title}</Typography>
                    <Typography variant="caption2">{message}</Typography>
                </Stack>
            </Paper>
        )
    },
)
